// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__2CG0z","button":"styles_button__dr0t2","icon":"styles_icon__39RbL"};